import { Link } from "react-router-dom";
import { BrandMark } from "./BrandMark";
import type { Shader } from "../types";

export function MastHead({ shaders }: { shaders: Shader[] }) {
  const latest = shaders[0];
  const currentWeek = latest ? `w${String(latest.week).padStart(2, "0")}` : "—";
  const year = latest ? latest.date.slice(0, 4) : new Date().getFullYear();

  return (
    <header className="masthead">
      <div className="mast__top">
        <Link to="/" className="brand">
          <BrandMark />
          <div className="brand__text">
            <h1 className="brand__name">shader brew</h1>
            <span className="brand__tag">a weekly fragment shader, by toshi</span>
          </div>
        </Link>
        <div className="mast__stats">
          <div>
            <b>{shaders.length}</b>
            <span>shaders</span>
          </div>
          <div>
            <b>{currentWeek}</b>
            <span>current</span>
          </div>
          <div>
            <b>{year}</b>
            <span>since '26</span>
          </div>
        </div>
      </div>
    </header>
  );
}
